/* Animația de restaurare din hero: 4 imagini suprapuse, dezvăluite pe rând, de la
   stânga la dreapta. Rulează doar cât e pe ecran și se oprește în fundal.
   Cu „prefers-reduced-motion” nu se animă: arată rezultatul și un buton pentru original. */
(function () {
  'use strict';

  function init(el) {
    if (el.hasAttribute('data-rf-bound')) return;
    el.setAttribute('data-rf-bound', '');

    var layers = el.querySelectorAll('[data-rf-restore-layer]');
    var steps = el.querySelectorAll('[data-rf-restore-step]');
    var dots = el.querySelectorAll('.rf-restore__dots i');
    var line = el.querySelector('[data-rf-restore-line]');
    var total = layers.length;
    if (total < 2) return;

    var stepMs = Math.max(1200, parseInt(el.getAttribute('data-step-ms'), 10) || 2000);
    var sweepMs = Math.round(stepMs * 0.6);
    el.style.setProperty('--rf-sweep', sweepMs + 'ms');

    if (RF.reducedMotion) return staticMode();

    var index = 0, timer = null, visible = false;

    function label(i) {
      steps.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n <= i); });
    }

    function sweep() {
      if (!line) return;
      line.classList.remove('is-sweeping');
      void line.offsetWidth;                       // repornește animația CSS
      line.classList.add('is-sweeping');
    }

    function next() {
      if (!visible) return;
      if (index < total - 1) {
        // straturile următoare se încarcă după prima fotografie: nu dezvăluim unul care încă nu a venit
        var img = layers[index + 1].querySelector('img');
        if (img && !img.complete) { timer = setTimeout(next, 250); return; }
        index += 1;
        el.classList.add('is-animating');
        layers[index].classList.add('is-on');
        label(index);
        sweep();
        timer = setTimeout(next, index === total - 1 ? stepMs + 2200 : stepMs);
      } else {
        // întoarcere lină la fotografia veche, apoi de la capăt
        el.classList.add('is-rewinding');
        timer = setTimeout(function () {
          el.classList.remove('is-animating');
          for (var i = 1; i < total; i++) layers[i].classList.remove('is-on');
          index = 0;
          label(0);
          void el.offsetWidth;
          el.classList.remove('is-rewinding');
          timer = setTimeout(next, 1100);
        }, 750);
      }
    }

    function play() { if (!timer) timer = setTimeout(next, index === 0 ? 1300 : 600); }
    function pause() { clearTimeout(timer); timer = null; }

    // imaginile etapelor trebuie să fie încărcate înainte de prima trecere
    function whenLoaded(cb) {
      var imgs = el.querySelectorAll('img'), left = imgs.length;
      if (!left) return cb();
      var done = function () { if (--left <= 0) cb(); };
      imgs.forEach(function (img) {
        if (img.complete) done();
        else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); }
      });
    }

    whenLoaded(function () {
      if (!('IntersectionObserver' in window)) { visible = true; return play(); }
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        visible && !document.hidden ? play() : pause();
      }, { threshold: 0.35 }).observe(el);
      document.addEventListener('visibilitychange', function () {
        document.hidden ? pause() : (visible && play());
      });
    });

    function staticMode() {
      el.classList.add('is-static');
      layers.forEach(function (l) { l.classList.add('is-on'); });
      var btn = el.querySelector('[data-rf-restore-toggle]');
      if (!btn) return;
      var text = btn.querySelector('[data-rf-restore-toggle-text]');
      var showingOriginal = false;
      btn.hidden = false;
      btn.addEventListener('click', function () {
        showingOriginal = !showingOriginal;
        for (var i = 1; i < total; i++) layers[i].classList.toggle('is-on', !showingOriginal);
        if (text) text.textContent = btn.getAttribute(showingOriginal ? 'data-t-restored' : 'data-t-original');
      });
    }
  }

  RF.register(function (root) { root.querySelectorAll('[data-rf-restore]').forEach(init); });
})();
